import { HelpLinkLibrary } from '@tableau/help-link-library';

import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { Helpers } from '../utils/Helpers';

const ONLINE_TOKEN_OFFLINE_PAGE_DICT: {[key: string]: string} = {
  'adminusers2': 'csvguidelines.htm',
  'status1': 'service_viewstatus.htm',
  'settings-adsync1': 'groups_globalsync.htm'
};

const TABLEAU_URL = 'https://www.tableau.com';

function search(searchText: string): void {
  searchText = encodeURIComponent(searchText);

  if (getSessionManagementService().offlineHelpEnabled()) {
    // Example: http://localhost/offline_help/en_us/help.htm#search-workbooks
    window.open(offlineHelpRoute('search-') + searchText, '_blank');
  } else {
    // Example: https://www.tableau.com/search/support/workbooks
    window.open(supportUrlPrefix() + '/search/support/' + searchText, '_blank');
  }
}

function getServerHelpUrlByCategory(category?: string): string {
  if (getSessionManagementService().offlineHelpEnabled()) {
    return offlineHelpRoute(ONLINE_TOKEN_OFFLINE_PAGE_DICT[category]);
  } else {
    if (category === undefined || category === 'undefined' || !category) {
      return buildUrl('server-help1');
    }
    let fullCategory = 'server-'.concat(category);
    return buildUrl(fullCategory);
  }
}

function getHelpUrlByCategory(category?: string, edition?: string, version?: string): string {
  let retval: string = '';
  retval = buildUrl(category);
  return retval;
}

function buildUrl(category?: string) {
  let helpLinkObj = new HelpLinkLibrary();
  category = category ?? 'help1';
  const identifiedLang: string = getSessionManagementService().sessionLanguage();
  helpLinkObj.setLanguage(identifiedLang);
  let language: string = helpLinkObj.getLanguage();
  let edition = getSessionManagementService().helpEdition() ?? 'server';
  let version = externalVersion();
  let platform: string = serverPlatform();
  helpLinkObj.setHelpUrl(language, edition, version, category, platform);
  let retval = helpLinkObj.getHelpUrl();
  return retval;
}

function getGeneralSupportUrl(): string {
  if (getSessionManagementService().helpEdition() !== 'online') {
    return this.supportUrlPrefix() + '/support';
  }
  // Open a support request (i.e., Zeus support form)
  return 'https://' + getSessionManagementService().sessionSupportHost() + getSessionManagementService().sessionSupportPath() +
    '?' + Helpers.serialize({
      'uid': getSessionManagementService().sessionAuthUserId(),
      'serverSiteUserId': getSessionManagementService().sessionUserId(),
      'serverSiteId': getSessionManagementService().sessionSiteLuid(),
      'serverInstanceId': getSessionManagementService().sessionServerId()
    });
}

function getSystemStatusUrl(): string {
  return 'https://trust.tableau.com/';
}

function getQueryParams(lang?: string): string {
  return Helpers.serialize({
    'edition': getSessionManagementService().helpEdition(),
    'lang': lang || helpUrlLanguage(),
    'platform': serverPlatform(),
    'version': externalVersion()
  });
}

function helpUrlLanguage(): string {
  let helpLinkObj = new HelpLinkLibrary();
  const language = getSessionManagementService().sessionLanguage();
  helpLinkObj.setLanguage(language);
  return helpLinkObj.getLanguage();
}

// Helper Functions

function getSessionManagementService() {
  return getSessionManagementServiceInstance();
}

function offlineHelpRoute(page?: string): string {
  const lang = helpUrlLanguage().replace('-', '_');
  return 'offline_help/' + lang + '/help.htm' + (page ? '#' + page : '');
}

function supportUrlPrefix(): string {
  const lang = helpUrlLanguage();
  return TABLEAU_URL + (lang === 'en-us' ? '' : '/' + lang);
}

function serverPlatform(): string {
  const server = getSessionManagementService().sessionServerVersion();
  const platform = server ? server.platform : '';
  return (platform) ? platform.toLowerCase() : 'windows'; // Default to Windows
}

function externalVersion(): string {
  const serverVersionInfo = getSessionManagementService().sessionServerVersion();
  if (!serverVersionInfo) {
    return '0.0';
  }
  const version = serverVersionInfo.externalVersion;
  const intRegExp = /^\d+$/;
  if (intRegExp.test(version.major) && intRegExp.test(version.minor)) {
    return version.major + '.' + version.minor;
  } else {
    return '0.0';
  }
}

export const HelpService = {
  search,
  getServerHelpUrlByCategory,
  getHelpUrlByCategory,
  supportUrlPrefix,
  getGeneralSupportUrl,
  externalVersion,
  getQueryParams,
  helpUrlLanguage,
  buildUrl,
  getSystemStatusUrl
};

export type HelpService = typeof HelpService;

